<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <h1 class="banner-sub-title wow fadeInLeft">GET IN TOUCH</h1>
              <h2 class="banner-title wow fadeInLeft" data-wow-duration="1.5s">Contact Us</h2>
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Home</a></li>
                <li>Contact</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/contact-bg.png" alt="Welcome banner image">
              <img src="../assets/images/phone-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/plane.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-697" class="full-width-content post-697 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="697" class="elementor elementor-697"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-69c8d6b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="69c8d6b" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9f6dce3"
                        data-id="9f6dce3" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-cbc49ec elementor-widget elementor-widget-xs-heading"
                              data-id="cbc49ec" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Find us</h3>
                                  <h2 class="heading-title">CONTACT <span>WITH US</span></h2>
                                </div>
                              </div>
                            </div>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-c24cfda elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="c24cfda" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-107ac5a"
                                    data-id="107ac5a" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-b3d2d3e elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="b3d2d3e" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="109" height="109"
                                                                                           src="../assets/images/contact-info-icon-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"/>
                                              </figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">Find us</h3>
                                                <p class="elementor-image-box-description"> 16 East 34th Street,New York,
                                                  NY 10016.
                                                  428, Seolleung-ro, Gangnam-gu, Seoul 06192.
                                                  9 Battery Road, Singapore, 049910.
                                                  1 Sussex Street, Barangaroo,Sydney, NSW 2000.
                                                  401 Collins Street, Melbourne, VIC 3000.
                                                  251 Tran Quang Khai, Tan Dinh Ward, District 1, VietNam.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7f2af97"
                                    data-id="7f2af97" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-3ba09af elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="3ba09af" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="109" height="109"
                                                                                           src="../assets/images/contact-info-icon-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"/>
                                              </figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">Make a Call</h3>
                                                <p class="elementor-image-box-description">+1 508 502 7059</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f454346"
                                    data-id="f454346" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-c87e869 elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="c87e869" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="109" height="109"
                                                                                           src="../assets/images/contact-info-icon-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"/>
                                              </figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">Send Mail</h3>
                                                <p class="elementor-image-box-description">info@episcloud.com</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-f8fdb54 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="f8fdb54" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-510290d"
                        data-id="510290d" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-9294d5e"
                        data-id="9294d5e" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-95056bf elementor-widget elementor-widget-xs-heading"
                              data-id="95056bf" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Have question?</h3>
                                  <h2 class="heading-title">SEND <span>A MESSAGE</span></h2>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-9244881 elementor-widget elementor-widget-shortcode"
                              data-id="9244881" data-element_type="widget" data-widget_type="shortcode.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-shortcode">
                                  <div role="form" class="wpcf7" id="wpcf7-f5-p697-o1" lang="en-US" dir="ltr">
                                    <div class="screen-reader-response"><p role="status" aria-live="polite"
                                                                           aria-atomic="true"></p>
                                      <ul></ul>
                                    </div>
                                    <form action="/contact/#wpcf7-f5-p697-o1" method="post" class="wpcf7-form init"
                                          novalidate="novalidate" data-status="init">
                                      <div style="display: none;">
                                        <input type="hidden" name="_wpcf7" value="5"/>
                                        <input type="hidden" name="_wpcf7_version" value="5.4.2"/>
                                        <input type="hidden" name="_wpcf7_locale" value="en_US"/>
                                        <input type="hidden" name="_wpcf7_unit_tag" value="wpcf7-f5-p697-o1"/>
                                        <input type="hidden" name="_wpcf7_container_post" value="697"/>
                                        <input type="hidden" name="_wpcf7_posted_data_hash" value=""/>
                                      </div>
                                      <div id="xs-contact-form" class="xs-form">
                                        <div class="form-group">
                                        <span class="wpcf7-form-control-wrap text-name"><input type="text"
                                                                                               name="text-name" value=""
                                                                                               size="40"
                                                                                               class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                                                                                               id="xs_contact_name"
                                                                                               aria-required="true"
                                                                                               aria-invalid="false"
                                                                                               placeholder="Name"/></span><br/>
                                          <span class="wpcf7-form-control-wrap your-email"><input type="email"
                                                                                                  name="your-email"
                                                                                                  value="" size="40"
                                                                                                  class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email form-control"
                                                                                                  id="xs_contact_email"
                                                                                                  aria-required="true"
                                                                                                  aria-invalid="false"
                                                                                                  placeholder="example@gmail.com"/></span><br/>
                                          <span class="wpcf7-form-control-wrap url-website"><input type="url"
                                                                                                   name="url-website"
                                                                                                   value="" size="40"
                                                                                                   class="wpcf7-form-control wpcf7-text wpcf7-url wpcf7-validates-as-required wpcf7-validates-as-url form-control"
                                                                                                   id="xs_contact_website"
                                                                                                   aria-required="true"
                                                                                                   aria-invalid="false"
                                                                                                   placeholder="Website"/></span><br/>
                                          <span class="wpcf7-form-control-wrap textarea-massage"><textarea
                                            name="textarea-massage" cols="40" rows="10"
                                            class="wpcf7-form-control wpcf7-textarea form-control" id="x_contact_massage"
                                            aria-invalid="false" placeholder="Question"></textarea></span>
                                        </div>
                                        <div class="xs-btn-wraper">
                                          <input type="submit" value="Submit Now"
                                                 class="wpcf7-form-control wpcf7-submit btn btn-primary"
                                                 id="xs_contact_submit"/>
                                        </div>
                                      </div>
                                      <div class="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-373c595"
                        data-id="373c595" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-882993f elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                  data-id="882993f" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-729e7ab"
                        data-id="729e7ab" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-1a06f80 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1a06f80" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ed702c8"
                        data-id="ed702c8" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-ce0a28a elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="ce0a28a" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy"/></div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-6b8ac10"
                        data-id="6b8ac10" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-0288dec elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="0288dec" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy"/></div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-7a7de5c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7a7de5c" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-122d56f"
                        data-id="122d56f" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-4370167 elementor-widget elementor-widget-spacer"
                              data-id="4370167" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
.elementor-697 .elementor-element.elementor-element-69c8d6b {
  padding: 80px 0px 80px 0px;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e.elementor-position-right .elementor-image-box-img {
  margin-left: 7px;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e.elementor-position-left .elementor-image-box-img {
  margin-right: 7px;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e.elementor-position-top .elementor-image-box-img {
  margin-bottom: 7px;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e .elementor-image-box-wrapper .elementor-image-box-img {
  width: 35%;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e .elementor-image-box-title {
  color: #1e1e1e;
  font-family: "Rubik", Sans-serif;
  font-size: 1.41176rem;
  font-weight: 500;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e .elementor-image-box-description {
  color: #70799f;
  font-family: "Karla", Sans-serif;
  line-height: 1.647em;
  letter-spacing: -0.4px;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e > .elementor-widget-container {
  padding: 27px 35px 35px 35px;
}

.elementor-697 .elementor-element.elementor-element-b3d2d3e:hover .elementor-widget-container {
  box-shadow: 0px 3px 33.6px 1.4px rgba(0, 0, 0, 0.1);
}

.elementor-697 .elementor-element.elementor-element-3ba09af.elementor-position-right .elementor-image-box-img {
  margin-left: 7px;
}

.elementor-697 .elementor-element.elementor-element-3ba09af.elementor-position-left .elementor-image-box-img {
  margin-right: 7px;
}

.elementor-697 .elementor-element.elementor-element-3ba09af.elementor-position-top .elementor-image-box-img {
  margin-bottom: 7px;
}

.elementor-697 .elementor-element.elementor-element-3ba09af .elementor-image-box-wrapper .elementor-image-box-img {
  width: 35%;
}

.elementor-697 .elementor-element.elementor-element-3ba09af .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-697 .elementor-element.elementor-element-3ba09af .elementor-image-box-title {
  color: #1e1e1e;
  font-family: "Rubik", Sans-serif;
  font-size: 1.41176rem;
  font-weight: 500;
}

.elementor-697 .elementor-element.elementor-element-3ba09af .elementor-image-box-description {
  color: #70799f;
  font-family: "Karla", Sans-serif;
  line-height: 1.647em;
  letter-spacing: -0.4px;
}

.elementor-697 .elementor-element.elementor-element-3ba09af > .elementor-widget-container {
  padding: 27px 35px 35px 35px;
  box-shadow: 0px 3px 33.6px 1.4px rgba(0, 0, 0, 0.1);
}

.elementor-697 .elementor-element.elementor-element-c87e869.elementor-position-right .elementor-image-box-img {
  margin-left: 7px;
}

.elementor-697 .elementor-element.elementor-element-c87e869.elementor-position-left .elementor-image-box-img {
  margin-right: 7px;
}

.elementor-697 .elementor-element.elementor-element-c87e869.elementor-position-top .elementor-image-box-img {
  margin-bottom: 7px;
}

.elementor-697 .elementor-element.elementor-element-c87e869 .elementor-image-box-wrapper .elementor-image-box-img {
  width: 35%;
}

.elementor-697 .elementor-element.elementor-element-c87e869 .elementor-image-box-img img {
  transition-duration: 0.3s;
}

.elementor-697 .elementor-element.elementor-element-c87e869 .elementor-image-box-title {
  color: #1e1e1e;
  font-family: "Rubik", Sans-serif;
  font-size: 1.41176rem;
  font-weight: 500;
}

.elementor-697 .elementor-element.elementor-element-c87e869 .elementor-image-box-description {
  color: #70799f;
  font-family: "Karla", Sans-serif;
  line-height: 1.647em;
  letter-spacing: -0.4px;
}

.elementor-697 .elementor-element.elementor-element-c87e869 > .elementor-widget-container {
  padding: 27px 35px 35px 35px;
}

.elementor-697 .elementor-element.elementor-element-c87e869:hover .elementor-widget-container {
  box-shadow: 0px 3px 33.6px 1.4px rgba(0, 0, 0, 0.1);
}

.elementor-697 .elementor-element.elementor-element-f8fdb54:not(.elementor-motion-effects-element-type-background), .elementor-697 .elementor-element.elementor-element-f8fdb54 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #f8fafe;
}

.elementor-697 .elementor-element.elementor-element-f8fdb54 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 100px 10px 100px 10px;
}

.elementor-697 .elementor-element.elementor-element-f8fdb54 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-697 .elementor-element.elementor-element-882993f {
  margin-top: 0px;
  margin-bottom: -158px;
}

.elementor-697 .elementor-element.elementor-element-729e7ab > .elementor-element-populated {
  padding: 0px 0px 0px 0px;
}

.elementor-697 .elementor-element.elementor-element-78f6cf7 iframe {
  height: 606px;
  filter: brightness(70%) contrast(190%) saturate(57%) blur(0px) hue-rotate(0deg);
}

.elementor-697 .elementor-element.elementor-element-1a06f80 {
  margin-top: 0px;
  margin-bottom: -110px;
}

.elementor-697 .elementor-element.elementor-element-ce0a28a .xs-feature-group {
  background-color: #ffffff;
}

.elementor-697 .elementor-element.elementor-element-ce0a28a .xs-feature-group .xs-title {
  color: #0c0c0c;
}

.elementor-697 .elementor-element.elementor-element-ce0a28a .xs-feature-group p {
  color: #70799f;
}

.elementor-697 .elementor-element.elementor-element-ce0a28a .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-697 .elementor-element.elementor-element-ce0a28a {
  z-index: 2;
}

.elementor-697 .elementor-element.elementor-element-ce0a28a > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-697 .elementor-element.elementor-element-0288dec .xs-feature-group {
  background-color: #ffffff;
}

.elementor-697 .elementor-element.elementor-element-0288dec .xs-feature-group .xs-title {
  color: #0c0c0c;
}

.elementor-697 .elementor-element.elementor-element-0288dec .xs-feature-group p {
  color: #70799f;
}

.elementor-697 .elementor-element.elementor-element-0288dec .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-697 .elementor-element.elementor-element-0288dec {
  z-index: 2;
}

.elementor-697 .elementor-element.elementor-element-0288dec > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-697 .elementor-element.elementor-element-7a7de5c:not(.elementor-motion-effects-element-type-background), .elementor-697 .elementor-element.elementor-element-7a7de5c > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #113072;
}

.elementor-697 .elementor-element.elementor-element-7a7de5c {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-697 .elementor-element.elementor-element-7a7de5c > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-697 .elementor-element.elementor-element-4370167 .elementor-spacer-inner {
  height: 80px;
}

@media (min-width: 768px) {
  .elementor-697 .elementor-element.elementor-element-510290d {
    width: 20%;
  }

  .elementor-697 .elementor-element.elementor-element-9294d5e {
    width: 59.333%;
  }

  .elementor-697 .elementor-element.elementor-element-373c595 {
    width: 20%;
  }
}

@media (max-width: 767px) {
  .elementor-697 .elementor-element.elementor-element-b3d2d3e .elementor-image-box-img {
    margin-bottom: 7px;
  }

  .elementor-697 .elementor-element.elementor-element-3ba09af .elementor-image-box-img {
    margin-bottom: 7px;
  }

  .elementor-697 .elementor-element.elementor-element-c87e869 .elementor-image-box-img {
    margin-bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue